import { Backdrop, Button, Paper, styled } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteMyAccount } from "../../../store/user/user-action";
import colors from "../../../theme/themeConstants";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
}

const DeleteAccountPopup = ({ isOpen, togglePopup }: IProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleCancelDelete = () => {
    togglePopup();
  };

  const handleDelete = () => {
    dispatch(deleteMyAccount());
    navigate("/");
  };

  return (
    <Backdrop open={isOpen} id={"popupOpen"}
      sx={{
        zIndex: 32
      }}
      onClick={togglePopup}
    >
      <Paper onClick={handleStopPropagation} sx={{
        margin: "0 1rem",
        borderRadius: "24px",
        padding: "2rem 30px",
        paddingTop: "40px"
      }}>
        <p>Are you sure want to delete your account? This action cannot be canceled.</p>
        <Button onClick={handleDelete} fullWidth sx={{
          border: "none",
          color: "black",
          textDecoration: "underline",
          background: "transparent",
          marginTop: "1.5rem",
          fontFamily: "Poppins",
          ":hover": {
            border: "none",
            background: "none",
          }
        }}>
          Yes, delete
        </Button>

        <CancelDeleteButton
          onClick={handleCancelDelete}
          variant="outlined"
          fullWidth
        >
          No, cancel
        </CancelDeleteButton>
      </Paper >
    </Backdrop >
  );
};

export default DeleteAccountPopup;

const CancelDeleteButton = styled(Button)({
  fontFamily: "Poppins",
  height: "52px",
  maxWidth: "83vw",
  margin: "1.5rem 0",
  marginBottom: "0",
  borderRadius: "38px",
  background: colors.purpleGradient,
  border: `1px solid ${colors.purple}`,
  color: "white",
  ":hover": { border: `1px solid ${colors.purple}` }
});
